<template>
  <div>
    <el-radio-group v-model="text"
                    :disabled="disabled"
                    @change="handleChange">
      <el-radio v-for="item in dataSource"
                :key="item.dictCode"
                :label="item[valueKey]">{{item[labelKey]}}</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
  import DictApi from '@/api/dict/DictApi';
  import encipherUtil from "@/util/encipher";
  let encipher = new encipherUtil()
  export default {
    name: "foreign-base-radio",
    props:{
      value:'',
      dictTypeCode:{
        type:String,
      },
      showAll:{
        type:Boolean,
        default:false
      },
      parentCode: {
        type: String,
        default: '-1'
      },
      disabled:{
        type:Boolean,
        default:false
      },
      labelKey: {
        type: String,
        default: 'dictName'
      },
      valueKey: {
        type: String,
        default: 'dictCode'
      },
    },
    data(){
      return{
        text:this.value,
        dataSource:[],
      }
    },
    created(){
      this.findDict()
    },
    methods:{
      handleChange(val){
        this.dataSource.forEach(item => {
          if(item[this.valueKey] == val){
            this.$emit("on-change", item)
          }
        })
      },
      findDict() {
        let params = {};
        params.dictTypeCode = this.dictTypeCode;
        params.status = 1;
        if(this.showAll){
          let dictApi = new DictApi();
          // 显示该字典类型全部数据
          dictApi.getDictListByTypeCode(params).then(res=>{
            this.dataSource = res.data;


          });
        }else{
          // 否则显示指定父级下的数据
          let dictApi = new DictApi();
          params.parentCode = this.parentCode;
          dictApi.getListByTypeCodeAndPCode(params).then(res=>{
            this.dataSource = res.data;
          });
        }
      },
    },
    watch:{
      value(curVal,oldVal){
        this.text = curVal;
        // 返回访问目的
        let visitOne=this.dataSource.find(item=>item.dictCode===curVal).dictName

        if(visitOne!=='女'&&visitOne!=='男'){
          encipher.setSessionStorageAES("visitMudi",visitOne)
        }
      },
      parentCode(curVal,oldVal){
        this.findDict()
      },
      text(curVal,oldVal){
        this.$emit("input", curVal)
      }
    }
  }
</script>

<style scoped>

</style>
